import axios from "axios";
import { toast } from "material-react-toastify";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../api";
import { AI_SCAN_DOCUMENT_TYPES, HTTP_METHODS } from "../Utils/CONST";
import { getActiveHotelId } from "../Utils/Utils";

const url = new URL(window.location.href);
const hotelId = url.searchParams.get("hotelId");
const COMMON_URL = `${process.env.REACT_APP_API_URL}`;
const JAVAURL = `${process.env.REACT_APP_SPRING_API_URL}`;
const BG_URL = `${process.env.REACT_APP_BG_API_URL}`;
const VIEWFOLIOS = "core/api/v1/folio/invoice-data-render/";
const CHECKINS = "core/api/v1/reservation/adminConfirmBooking/";
const CHECKOUTS = "core/api/v1/reservation/checkout-booking/";

export const viewFolio = async (id) => {
  return axios
    .get(COMMON_URL + VIEWFOLIOS + "?bookingId=" + id + "&fromDB=false")
    .then((resp) => resp.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const checkin = async (id) => {
  try {
    const res = await axios.get(BG_URL + CHECKINS + "?bookingId=" + id);
    await handleGetDoorLockDetails(id);
    return res.data;
  } catch (err) {
    toast.error(err.response.data);
  }
  // return axios
  //   .get(JAVAURL + CHECKINS + "?bookingId=" + id)
  //   .then((resp) => resp.data)
  //   .catch((err) => {
  //     toast.error(err.response.data);
  //   });
};

export const handleGetDoorLockDetails = async (bookingId) => {
  if (sessionStorage.getItem(`xytronEnabled${hotelId}`) === "true") {
    try {
      const doorLockDetails = await handleSpringDataRequest(
        `core/api/v1/xytron/get-door-lock-details?bookingId=${bookingId}`
      );
      await handleMakeXytronCard(doorLockDetails);
    } catch (err) {
      console.log(err);
    }
  }
};

const handleMakeXytronCard = async (doorLockDetails) => {
  for (let details of doorLockDetails) {
    try {
      delete details["booking_status"];
      const res = await axios.post(
        "http://127.0.0.1:8081/makecard.php",
        details
      );
      // setMakeCardLogs((prev) => ({ ...prev, [details["booking_id"]]: res }));
    } catch (err) {
      console.log(err);
      // setMakeCardLogs((prev) => ({ ...prev, [details["booking_id"]]: err }));
    }
  }
};

export const checkout = async (id) => {
  return axios
    .post(
      BG_URL + CHECKOUTS + "?bookingId=" + id + "&releaseInventory=" + "false",
      {}
    )
    .then((resp) => resp.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const scanDocumentApi = ({
  govtIdType,
  onStart,
  onSuccess,
  onComplete,
  cameraImage,
  deviceImage,
  uploadDeviceType,
}) => {
  if (!govtIdType) {
    return toast.error("Please select the document type");
  }

  if (
    ![
      AI_SCAN_DOCUMENT_TYPES.DRIVERS_LICENSE,
      AI_SCAN_DOCUMENT_TYPES.PASSPORT,
    ].includes(govtIdType)
  ) {
    return toast.error(
      "Please select the document type as Drivers License or Passport for scanning"
    );
  }

  let base64Image = null;
  if (uploadDeviceType === "Device") {
    if (deviceImage.length <= 0) {
      return toast.error("Please upload the front image");
    }
    base64Image = deviceImage[0]?.data_url;
  } else {
    if (!cameraImage) {
      return toast.error("Please upload the front image");
    }
    base64Image = cameraImage;
  }

  onStart();
  handleSpringDataMutationRequest(
    HTTP_METHODS.POST,
    `core/api/v1/document-ai/fetch-id-info-base64`,
    {
      imageType: "image/png",
      docType: govtIdType,
      base64Image: base64Image?.split(",")[1],
      hotelId: hotelId,
    }
  )
    .then((res) => {
      if (res?.isValid === false) {
        toast.error("Not a valid ID", {
          closeOnClick: true,
          pauseOnHover: true,
          autoClose: 8000,
        });
      } else if (res?.isValid === true && res?.isExpired === true) {
        toast.warning("ID appears to have expired", {
          closeOnClick: true,
          pauseOnHover: true,
          autoClose: 8000,
        });
      } else {
        onSuccess(res);
      }
    })
    .catch((err) => {
      toast.error("Error in scanning the document");
    })
    .finally(() => onComplete?.());
};
